import numbro from 'numbro';

numbro.registerLanguage({
  languageTag: 'it',
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€',
    position: 'prefix', // optional: can be 'postfix'
    code: 'EUR',
  },
});

numbro.setLanguage('it');

export const numberFormat = function (value) {
  if (typeof value === 'string') {
    value = Number(value);
  }

  if (Number.isNaN(value)) {
    return value;
  }

  return numbro(value).format(); // Uses default locale
};

export const numberParse = function (str) {
  return numbro.unformat(str); // Similar to numeral(str).value()
};
